import React from "react";
import { motion } from "framer-motion";
import { GoldDivider } from "./Ornaments";
import { EVENTS } from "../lib/invitationData";

const ease = [0.22, 0.61, 0.36, 1];

export const Timeline = () => {
    return (
        <section
            id="timeline"
            data-testid="timeline-section"
            className="relative w-full py-32 md:py-48 paper-grain overflow-hidden"
            style={{ backgroundColor: "#16130e" }}
        >
            <div className="mx-auto max-w-4xl px-6 text-center">
                <motion.p
                    initial={{ opacity: 0, y: 10 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 1, ease }}
                    className="tracking-editorial uppercase text-[10px] text-[color:var(--gold-deep)]"
                >
                    Three Days of Celebration
                </motion.p>
                <motion.h2
                    initial={{ opacity: 0, y: 16 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ delay: 0.15, duration: 1.2, ease }}
                    className="font-serif-display mt-4 text-4xl md:text-6xl font-light text-[color:var(--charcoal)]"
                >
                    The Journey
                </motion.h2>
                <motion.div
                    initial={{ opacity: 0 }}
                    whileInView={{ opacity: 1 }}
                    viewport={{ once: true }}
                    transition={{ delay: 0.3, duration: 1 }}
                    className="mt-6"
                >
                    <GoldDivider />
                </motion.div>
            </div>

            <div className="relative mx-auto mt-24 max-w-2xl px-6">
                {/* central vertical line */}
                <div
                    className="absolute left-1/2 top-0 bottom-0 w-px bg-gradient-to-b from-transparent via-[color:var(--gold)]/60 to-transparent -translate-x-1/2"
                    aria-hidden="true"
                />

                {EVENTS.map((event, i) => (
                    <motion.div
                        key={event.id}
                        initial={{ opacity: 0, y: 40 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, margin: "-120px" }}
                        transition={{ duration: 1.2, ease, delay: 0.1 }}
                        className={`relative flex ${
                            i % 2 === 0 ? "justify-start" : "justify-end"
                        } py-10 md:py-14`}
                    >
                        {/* node */}
                        <span
                            className="timeline-node absolute left-1/2 top-16 -translate-x-1/2 h-2.5 w-2.5 rounded-full bg-[color:var(--gold)]"
                            aria-hidden="true"
                        />

                        <a
                            href={`#${event.id}`}
                            onClick={(e) => {
                                e.preventDefault();
                                document
                                    .getElementById(event.id)
                                    ?.scrollIntoView({
                                        behavior: "smooth",
                                        block: "start",
                                    });
                            }}
                            data-testid={`timeline-card-${event.id}`}
                            className={`group block w-[45%] ${
                                i % 2 === 0 ? "pr-10 text-right" : "pl-10 text-left"
                            }`}
                        >
                            <div className="transition-transform duration-700 ease-in-out group-hover:-translate-y-1">
                                <p className="tracking-editorial uppercase text-[10px] text-[color:var(--gold-deep)]">
                                    {event.day}
                                </p>
                                <h3 className="font-serif-display text-3xl md:text-4xl font-light text-[color:var(--charcoal)] mt-2">
                                    {event.title}
                                </h3>
                                <p className="font-serif-display italic text-[color:var(--muted)] mt-1 text-sm md:text-base">
                                    {event.subtitle}
                                </p>
                                <p className="mt-3 text-xs tracking-[0.24em] uppercase text-[color:var(--charcoal-soft)]">
                                    {event.date}
                                </p>
                            </div>
                        </a>
                    </motion.div>
                ))}
            </div>
        </section>
    );
};

export default Timeline;
